export default {
  headline: "Ausbildungsnachweis",
  name: "Name, Vorname",
  interval: "Berichtszeitraum von*",
  interval_invalid: "Bitte geben sie einen Berichtzeitraum an",
  interval_2: "bis*",
  interval_2_invalid: " ",
  service: "Dienst",
  location: "Einsatzort",
  comments: "Bemerkungen Lehrfahrer",
  comments_employee: "Anmerkungen/Hinweise/Wünsche Einzuweisender",
  signature: "Unterschrift {name}",
  signature_trainee: "Unterschrift Auszubildender",
  evaluator: "Lehrfahrer",
  signature_invalid: "Bitte unterschreiben Sie das Formular",
  date: "Datum",
  operation_part: "Betriebsteil",
  operation_part_invalid: "Betriebsteil",
}
